import type { ResearchHit, ResearchSource } from "./types";

/**
 * The immigration library tabs, in the order the composer offers them.
 * They match `GET /api/research/legal` and the CaseBlink research MCP.
 */
export const RESEARCH_SOURCES: ResearchSource[] = [
  {
    id: "case_law",
    label: "Case Law",
    authority: "Published precedent. The court on each hit says who it binds.",
    askAs:
      "published BIA, AAO, Attorney General, and federal court immigration decisions"
  },
  {
    id: "unpublished",
    label: "Unpublished & Non-Precedent",
    authority: "Persuasive only. Not Matter of or AAO precedent.",
    askAs: "unpublished BIA decisions and AAO non-precedent decisions"
  },
  {
    id: "statutes",
    label: "Statutes & Regs",
    authority: "The statute and the current regulations. Cite the section.",
    askAs: "the INA, 8 U.S.C., and 8 C.F.R."
  },
  {
    id: "references",
    label: "Policy & Practice Manuals",
    authority: "Agency guidance. Not binding on judges.",
    askAs: "the USCIS Policy Manual and EOIR practice manuals"
  }
];

const yearOf = (date: string | null) => /^\d{4}/.exec(date ?? "")?.[0] ?? null;

/** "Matter of Dhanasar, 26 I&N Dec. 884 (2016)": a hit as prose cites it. */
export const citeHit = (hit: ResearchHit): string => {
  const citation =
    hit.citation && hit.citation !== hit.title ? `, ${hit.citation}` : "";
  const year = yearOf(hit.date);
  return `${hit.title}${citation}${year ? ` (${year})` : ""}`;
};

/** The prompt that hands a search to the agent instead. */
export const askPrompt = (source: ResearchSource, query: string): string =>
  `Search ${
    source.askAs
  } for: ${query.trim()}. Summarize what applies to this case and cite each source.`;
